import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Input from '../../components/Input';
import Grid from '../../components/Grid';
import messages from './messages';
import SubscriptionActive from '../../components/SubscriptionActive';
import SubscriptionInActive from '../../components/SubscriptionInactive';
import * as constants from '../Authorization/constants';
import './styles.css';

export const EventNotesComponent = ({ hsNotes, onChange, intl }) => (
  <div styleName="sidebar-grid">
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <h2 styleName="section-title">
            <FormattedMessage {...messages.internalNotes} />
          </h2>
          <div size="small">
            <FormattedMessage {...messages.notes} />
          </div>
          <div>
            <SubscriptionActive anyOf={constants.REP_VISITS_SUBSCRIPTION}>
              <Grid.Row>
                <Input fluid name="notes" onChange={onChange}>
                  <input aria-label={intl.formatMessage(messages.internalNotes)} value={hsNotes} />
                </Input>
              </Grid.Row>
            </SubscriptionActive>
            <SubscriptionInActive allOf={constants.REP_VISITS_SUBSCRIPTION}>
              <Grid.Row>
                <Input fluid name="notes-disabled">
                  <input disabled placeholder={intl.formatMessage(messages.notesPlaceholder)} />
                </Input>
              </Grid.Row>
            </SubscriptionInActive>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
);

EventNotesComponent.propTypes = {
  hsNotes: PropTypes.string,
  onChange: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

const InternalNotes = injectIntl(EventNotesComponent);
export default InternalNotes;
